<app-profile-sub-header path="Login & Security" text="If you wish to update the e-mail address or password associated with this account, please fill in the following
fields. Your password is requested for security reasons."></app-profile-sub-header>

<p class="email-sub">Your current e-mail address is: <span class="email-text">{{ user?.email }}</span></p>

<div class="row form-container">
    <div class="col-12 text-label">
        <p>Change of Email</p>
    </div>
    <div class="col-12 mb-3 input-group">
        <input type="text" class="form-control" placeholder="Current Password" aria-label="Password">
        <span class="input-group-text"><i class="fas fa-eye-slash fa-lg"></i></span>
    </div>
    <div class="col-md-6 col-xs-12 mt-md-0">
        <input type="text" class="form-control" placeholder="New Email Address" aria-label="email">
    </div>
    <div class="col-md-6 col-xs-12 mt-3 mt-md-0">
        <input type="text" class="form-control" placeholder="Repeat Email Address" aria-label="email">
    </div>
    <div class="col-12 d-grid btn-col">
        <button class="btn btn-primary ue-btn" type="button">UPDATE EMAIL</button>
    </div>
</div>

<div class="row form-container password-container">
    <div class="col-12 text-label">
        <p>Change of Password</p>
    </div>
    <div class="col-12 mb-3 input-group">
        <input type="text" class="form-control" placeholder="Current Password" aria-label="Password">
        <span class="input-group-text"><i class="fas fa-eye-slash fa-lg"></i></span>
    </div>
    <div class="col-md-6 col-xs-12 mt-md-0">
        <input type="text" class="form-control" placeholder="New Password" aria-label="Password">
    </div>
    <div class="col-md-6 col-xs-12 mt-3 mt-md-0">
        <input type="text" class="form-control" placeholder="Repeat Password" aria-label="Password">
    </div>
    <div class="col-12 d-grid btn-col">
        <button class="btn btn-primary ue-btn" type="button">UPDATE PASSWORD</button>
    </div>
</div>